<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <!-- <sidebar-link to="/main">
        <i class="nc-icon nc-money-coins"></i>
        <p>Sayfalar</p>
      </sidebar-link>-->
      <sidebar-link to="/main">
        <i class="nc-icon nc-album-2"></i>
        <p>Anasayfa</p>
      </sidebar-link>
      <!-- <sidebar-link to="/intro-video">
        <i class="nc-icon nc-album-2"></i>
        <p>Intro Videosu</p>
      </sidebar-link> -->
      <sidebar-link to="/directors">
        <i class="nc-icon nc-align-center"></i>
        <p>Kurumsal</p>
      </sidebar-link>
      <sidebar-link to="/leader">
        <i class="nc-icon nc-single-copy-04"></i>
        <p>Başkanın Bölümü</p>
      </sidebar-link>
      <sidebar-link to="/gallery">
        <i class="nc-icon nc-single-02"></i>
        <p>Galeri</p>
      </sidebar-link>
      <sidebar-link to="/categories">
        <i class="nc-icon nc-bold"></i>
        <p>Bildiri Kategorileri</p>
      </sidebar-link>
      <sidebar-link to="/newcategories">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Haber Kategorileri</p>
      </sidebar-link>
      <sidebar-link to="/races">
        <i class="nc-icon nc-delivery-fast"></i>
        <p>Yarışlar</p>
      </sidebar-link>
      <!-- <sidebar-link to="/comments">
        <i class="nc-icon nc-chat-round"></i>
        <p>Yorumlar</p>
      </sidebar-link>
      <sidebar-link to="/reports">
        <i class="nc-icon nc-notification-70"></i>
        <p>Şikayetler</p>
      </sidebar-link>
      <sidebar-link to="/feedbacks">
        <i class="nc-icon nc-bell-55"></i>
        <p>Geri Bildirimler</p>
      </sidebar-link>-->
      <sidebar-link to="/news">
        <i class="nc-icon nc-notification-70"></i>
        <p>Bildiriler</p>
      </sidebar-link>
      <sidebar-link to="/allnews">
        <i class="nc-icon nc-paper-2"></i>
        <p>Haberler</p>
      </sidebar-link>
      <sidebar-link to="/coming-from-you">
        <i class="nc-icon nc-email-85"></i>
        <p>Sizden Gelenler</p>
      </sidebar-link>
      <sidebar-link to="/featured">
        <i class="nc-icon nc-quote"></i>
        <p>Vitrin</p>
      </sidebar-link>
      <sidebar-link to="/activity-program-page">
        <i class="nc-icon nc-bus-front-12"></i>
        <p>Faaliyet Programı</p>
      </sidebar-link>
      <sidebar-link to="/cup-point-page">
        <i class="nc-icon nc-bus-front-12"></i>
        <p>Kupa Puanları</p>
      </sidebar-link>
      <sidebar-link to="/information-banks-page">
        <i class="nc-icon nc-grid-45"></i>
        <p>Bilgi Bankası</p>
      </sidebar-link>
      <!-- <sidebar-link to="/dictionary">
        <i class="nc-icon nc-paper-2"></i>
        <p>Sözlük</p>
      </sidebar-link>-->
      <!-- <sidebar-link to="/menus">
        <i class="nc-icon nc-vector"></i>
        <p>Menu Yönetimi</p>
      </sidebar-link>-->
      <!-- <sidebar-link to="/educations">
        <i class="nc-icon nc-layers-3"></i>
        <p>Eğitimler</p>
      </sidebar-link>-->
      <sidebar-link to="/facilities">
        <i class="nc-icon nc-bank"></i>
        <p>Tesisler</p>
      </sidebar-link>
      <!-- <sidebar-link to="/ads">
        <i class="nc-icon nc-layers-3"></i>
        <p>Reklam Yönetimi</p>
      </sidebar-link>-->
      <sidebar-link to="/newsletter">
        <i class="nc-icon nc-email-85"></i>
        <p>E-Bülten</p>
      </sidebar-link>
      <sidebar-link to="/activity-program">
        <i class="nc-icon nc-cloud-upload-94"></i>
        <p>Excel Yüklemeleri</p>
      </sidebar-link>
      <!-- <sidebar-link to="/static-pages">
        <i class="nc-icon nc-notes"></i>
        <p>Sabit Sayfalar</p>
      </sidebar-link>-->
      <sidebar-link to="/users">
        <i class="nc-icon nc-circle-09"></i>
        <p>Kullanıcılar</p>
      </sidebar-link>
      <!-- <sidebar-link to="/members">
        <i class="nc-icon nc-circle-09"></i>
        <p>Üyeler</p>
      </sidebar-link> -->
      <!-- <sidebar-link to="/homeboxes">
        <i class="nc-icon nc-settings-tool-66"></i>
        <p>Anasayfa Kutular</p>
      </sidebar-link>-->
      <sidebar-link to="/settings">
        <i class="nc-icon nc-settings-gear-64"></i>
        <p>Ayarlar</p>
      </sidebar-link>
      <sidebar-link to="/scores">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Sonuçlar</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue"
import ContentFooter from "./ContentFooter.vue"
import DashboardContent from "./Content.vue"
import MobileMenu from "./MobileMenu.vue"
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue